import React, { useEffect, useState } from "react";
import { Button, Card, Form, Label, Spinner } from "reactstrap";
import { BiMinus, BiPlus } from "react-icons/bi";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { createMenuAPI, getMenuListAPI } from "../../api/menu";
import Required from "../../myComponents/validate/Required";
import CKEditor from "../../myComponents/CK Editor/Index";
import Select from "react-select";
import { toast } from "react-toastify";
import { decrypt, encrypt } from "../../utils/Encrypt";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import { verifyAPI } from "../../api";
import useLogout from "../../utils/Utils";
const SubMenu = ({}) => {
  const logout= useLogout()
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mode, setMode] = useState("Add");
  const [data, setData] = useState([]);
  const [menuList, setMenuList] = useState([]);
    // state to store response true or false of CK_Editor
  const [isCKEditor, setIsCKEditor] = useState(true);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });
  useEffect(() => {
    const m = location?.state?.row;
    setValue("menu", m?.menu);
    setValue("menu_hn", m.hn_menu);
    setValue("page_title", m.page_title);
    setValue("hn_page_title", m.hn_page_title);

    setValue(
      "subMenuList",
      m?.submenu?.map((item) => ({
        value: item.id,
        label: item.menu,
      }))
    );
    getMenuData();
    getVerifyDataApi()
  }, []);
  const getMenuData = () => {
    const data = {};
    getMenuListAPI(data)
      .then((res) => {
        if (res?.data?.status === "success") {
          setMenuList(res.data.data.tableData);
          //   toast.success(res.data.message);
        } else {
          setMenuList([]);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handlePageTypeChange = (selectedOption) => {
    setValue("page_type", selectedOption);
    trigger("page_type");
  };
  const handleStatusChange = (selectedOption) => {
    setValue("status", selectedOption);
    trigger("status");
  };
  const handleSubMenuChange = (selectedOption) => {
    setValue("sub_menu_list", selectedOption);
    trigger("sub_menu_list");
  };
    const getVerifyDataApi = () => {
      const data = {};
      verifyAPI(data)
        .then((res) => {
          // decrypt data
          const status = decrypt(res.data.status);
  
          const dataVerify = decrypt(res.data?.data);
          if (status === "success") {
            const responseData = dataVerify.ck_editor;
            setIsCKEditor(responseData);
            toast.success(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "failed") {
            toast.warning(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            toast.error(res.data.message);
            logout();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    };
  const onFormSubmit = (data) => {
    setIsLoading(true); 
       let cleanedContent=''; 
    let cleanedContentHN=''; 
    if(isCKEditor ){
    const description = window?.CKEDITOR?.instances.page?.getData();
    const hn_description = window?.CKEDITOR?.instances.pagehn?.getData();
     cleanedContent = description.replace(/&nbsp;/g, ' ');
      cleanedContentHN = hn_description.replace(/&nbsp;/g, ' ');
    }
    const body = {
      module: "Sub Menu",
      parent_id: data?.sub_menu_list ? data?.sub_menu_list?.value : location?.state?.row?.id,
      page_title: data.page_title,
      hn_page_title: data.hn_page_title,
      menu: data?.sub_menu,
      hn_menu: data.sub_menu_hn,
      page_type: data?.page_type?.value,
      slug: data?.page_url,
      page_url:
        watch("page_type")?.value == "Static" || watch("page_type")?.value == "Static"
          ? `/pages/${data?.page_url}`
          : data.page_url,
      status: data?.status?.value,
      ...((watch("page_type")?.value == "Static" || watch("page_type")?.value == "Link") && {
        description: cleanedContent,
      }),
      ...((watch("page_type")?.value == "Static" || watch("page_type")?.value == "Link") && {
        hn_description: cleanedContentHN,
      }),
      ...(mode == "Edit" && { id: watch("id") }),
    };
    const encryptedData = encrypt(body);
    const encryptData = {
      zero: encryptedData,
    };

    if (mode == "Add") {
      createMenuAPI(encryptData)
        .then((res) => {
          if (res.data.status == "success") {
            toast.success(res.data.message);
            navigate("/admin/manage-menu");
            setIsOpen(false);
            setIsLoading(false);
          } else if (res.data.status === "failed") {
            setIsLoading(false);
            toast.warning(res.data.message);
          } else if (res.data.state === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            // logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    }
  };

  return (
    <>
      <Head title={"Manage Sub Menu"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Menu"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button size="xs" color="primary" className={`  me-n1`} onClick={() => navigate(-1)}>
                  <Icon className={`me-1`} name="arrow-left" /> Back
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <Row className={`g-gs`}>
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row className={`g-gs`}>
                  {/*Menu */}
                  <Col md="4" sm="3" xxl="2">
                    <div className="form-group">
                      <Label className="form-label" htmlFor="menu">
                        {"Menu"} <Required />
                      </Label>
                      <div className="form-control-wrap">
                        <input
                          placeholder={"Enter menu"}
                          type="text"
                          id="menu"
                          disabled
                          className="form-control"
                          value={watch("menu")}
                        />
                      </div>
                    </div>
                  </Col>{" "}
                  {/*Menu HN */}
                  <Col md="4" sm="3" xxl="2">
                    <div className="form-group">
                      <Label className="form-label" htmlFor="menu_hn">
                        {"Menu Hindi"} <Required />
                      </Label>
                      <div className="form-control-wrap">
                        <input
                          placeholder={"Enter menu in hindi"}
                          type="text"
                          id="menu_hn"
                          disabled
                          className="form-control"
                          value={watch("menu_hn")}
                        />
                      </div>
                    </div>
                  </Col>{" "}
                  {/*Page Title */}
                  <Col md="4" sm="3" xxl="4">
                    <div className="form-group">
                      <Label className="form-label" htmlFor="page_title">
                        {"Page Title"} <Required />
                      </Label>
                      <div className="form-control-wrap">
                        <input
                          placeholder={"Enter page_title"}
                          type="text"
                          id="page_title"
                          {...register("page_title", {
                            required: {
                              value: true,
                              message: "page_title is required",
                            },
                            // pattern: {
                            //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                            //   message: "Only alphabets are allowed",
                            // },
                            minLength: {
                              value: 3,
                              message: "page_title must be at least 2 characters long",
                            },
                            maxLength: {
                              value: 50,
                              message: "page_title cannot exceed 50 characters",
                            },
                          })}
                          className="form-control"
                          value={watch("page_title")}
                          onChange={(e) => {
                            // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                            // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                            setValue("page_title", e.target.value);
                            trigger("page_title"); // Trigger validation
                          }}
                          // onInput={(e) => {
                          //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                          // }}
                        />
                        {errors.page_title && <span className="invalid">{errors?.page_title?.message}</span>}
                      </div>
                    </div>
                  </Col>{" "}
                  {/*Page Title HN */}
                  <Col md="4" sm="3" xxl="4">
                    <div className="form-group">
                      <Label className="form-label" htmlFor="hn_page_title">
                        {"Page Title Hindi"} <Required />
                      </Label>
                      <div className="form-control-wrap">
                        <input
                          placeholder={"Enter page title in hindi"}
                          type="text"
                          id="hn_page_title"
                          {...register("page title", {
                            required: {
                              value: true,
                              message: "page title is required",
                            },
                            // pattern: {
                            //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                            //   message: "Only alphabets are allowed",
                            // },
                            minLength: {
                              value: 3,
                              message: "page title must be at least 2 characters long",
                            },
                            maxLength: {
                              value: 50,
                              message: "page title cannot exceed 50 characters",
                            },
                          })}
                          className="form-control"
                          value={watch("hn_page_title")}
                          onChange={(e) => {
                            // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                            // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                            setValue("hn_page_title", e.target.value);
                            trigger("hn_page_title"); // Trigger validation
                          }}
                          // onInput={(e) => {
                          //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                          // }}
                        />
                        {errors.hn_page_title && <span className="invalid">{errors?.hn_page_title?.message}</span>}
                      </div>
                    </div>
                  </Col>{" "}
                  {/* Sub Menu List */}
                  <Col md="4" sm="3" xxl="2">
                    <div className="form-group">
                      <Label className="from-label" htmlFor="sub_menu_list">
                        Sub Menu List
                      </Label>
                      <div className="form-control-wrap">
                        <Select
                          className=""
                          id="sub_menu_list"
                          options={watch("subMenuList")}
                          {...register("sub_menu_list", {})}
                          onChange={handleSubMenuChange}
                          value={watch("sub_menu_list")}
                        />
                        {errors.sub_menu_list && (
                          <span
                            className="invalid"
                            style={{
                              color: "#e85347",
                              fontSize: "11px",
                              fontStyle: "italic",
                            }}
                          >
                            {errors?.sub_menu_list?.message}
                          </span>
                        )}
                      </div>
                    </div>
                  </Col>
                  {/*Sub Menu */}
                  <Col md="4" sm="3" xxl="5">
                    <div className="form-group">
                      <Label className="form-label" htmlFor="sub-menu">
                        {"Sub Menu"} <Required />
                      </Label>
                      <div className="form-control-wrap">
                        <input
                          placeholder={"Enter sub menu"}
                          type="text"
                          id="sub-menu"
                          {...register("sub_menu", {
                            required: {
                              value: true,
                              message: "sub menu is required",
                            },
                            // pattern: {
                            //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                            //   message: "Only alphabets are allowed",
                            // },
                            minLength: {
                              value: 3,
                              message: "sub menu must be at least 2 characters long",
                            },
                            maxLength: {
                              value: 50,
                              message: "sub menu cannot exceed 50 characters",
                            },
                          })}
                          className="form-control"
                          value={watch("sub_menu")}
                          onChange={(e) => {
                            // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                            // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                            setValue("sub_menu", e.target.value);
                            trigger("sub_menu"); // Trigger validation
                          }}
                          // onInput={(e) => {
                          //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                          // }}
                        />
                        {errors.sub_menu && <span className="invalid">{errors?.sub_menu?.message}</span>}
                      </div>
                    </div>
                  </Col>{" "}
                  {/* Sub Menu HN */}
                  <Col md="4" sm="3" xxl="5">
                    <div className="form-group">
                      <Label className="form-label" htmlFor="sub_menu_hn">
                        {"Sub Menu Hindi"} <Required />
                      </Label>
                      <div className="form-control-wrap">
                        <input
                          placeholder={"Enter sub menu in hindi"}
                          type="text"
                          id="sub_menu_hn"
                          {...register("sub_menu_hn", {
                            required: {
                              value: true,
                              message: "sub menu is required",
                            },
                            // pattern: {
                            //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                            //   message: "Only alphabets are allowed",
                            // },
                            minLength: {
                              value: 3,
                              message: "sub menu must be at least 2 characters long",
                            },
                            maxLength: {
                              value: 50,
                              message: "sub menu cannot exceed 50 characters",
                            },
                          })}
                          className="form-control"
                          value={watch("sub_menu_hn")}
                          onChange={(e) => {
                            // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                            // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                            setValue("sub_menu_hn", e.target.value);
                            trigger("sub_menu_hn"); // Trigger validation
                          }}
                          // onInput={(e) => {
                          //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                          // }}
                        />
                        {errors.sub_menu_hn && <span className="invalid">{errors?.sub_menu_hn?.message}</span>}
                      </div>
                    </div>
                  </Col>{" "}
                  {/* Page Type */}
                  <Col md="4" sm="3" xxl="2">
                    <div className="form-group">
                      <Label className="from-label" htmlFor="page_type">
                        Page Type
                      </Label>
                      <div className="form-control-wrap">
                        <Select
                          className=""
                          id="page_type"
                          options={[
                            { value: "Link", label: "Link" },
                            { value: "Static", label: "Static" },
                            { value: "Dynamic", label: "Dynamic" },
                          ]}
                          {...register("page_type", {
                            required: "Please select page type",
                          })}
                          onChange={handlePageTypeChange}
                          value={watch("page_type")}
                        />
                        {errors.page_type && (
                          <span
                            className="invalid"
                            style={{
                              color: "#e85347",
                              fontSize: "11px",
                              fontStyle: "italic",
                            }}
                          >
                            {errors?.page_type?.message}
                          </span>
                        )}
                      </div>
                    </div>
                  </Col>
                  {/*Page URL */}
                  <Col md="4" sm="3" xxl="8">
                    <div className="form-group">
                      <Label className="form-label" htmlFor="page_url">
                        {"Page URL"} <Required />
                      </Label>
                      <div className="form-control-wrap">
                        <input
                          placeholder={"Enter page url"}
                          type="text"
                          id="page_url"
                          {...register("page_url", {
                            required: {
                              value: true,
                              message: "page url is required",
                            },
                            // pattern: {
                            //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                            //   message: "Only alphabets are allowed",
                            // },
                            minLength: {
                              value: 1,
                              message: "page url must be at least 1 characters long",
                            },
                            maxLength: {
                              value: 100,
                              message: "page url cannot exceed 100 characters",
                            },
                          })}
                          className="form-control"
                          value={watch("page_url")}
                          onChange={(e) => {
                            // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                            // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                            setValue("page_url", e.target.value);
                            trigger("page_url"); // Trigger validation
                          }}
                          // onInput={(e) => {
                          //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                          // }}
                        />
                        {errors.page_url && <span className="invalid">{errors?.page_url?.message}</span>}
                      </div>
                    </div>
                  </Col>{" "}
                  {/* Status */}
                  <Col md="4" sm="3" xxl="2">
                    <div className="form-group">
                      <Label className="from-label" htmlFor="status">
                        Status
                      </Label>
                      <div className="form-control-wrap">
                        <Select
                          className=""
                          id="status"
                          options={[
                            { value: true, label: "Active" },
                            { value: false, label: "InActive" },
                          ]}
                          {...register("status", {
                            required: "Please select status",
                          })}
                          onChange={handleStatusChange}
                          value={watch("status")}
                        />
                        {errors.status && (
                          <span
                            className="invalid"
                            style={{
                              color: "#e85347",
                              fontSize: "11px",
                              fontStyle: "italic",
                            }}
                          >
                            {errors?.status?.message}
                          </span>
                        )}
                      </div>
                    </div>
                  </Col>
                  {/* CK EDITOR */}
                  {(watch("page_type")?.value == "Static" || watch("page_type")?.value == "Link") && (
                    <Col md="12" sm="12" xxl="6">
                      {isCKEditor ? <CKEditor title={"Page Content"} id={"page"} /> :<>
                       <Label htmlFor="page_content_hn" className="form-label">
                              {"Page Content"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <textarea
                                rows={15}
                                placeholder={"Enter page content"}
                                type="text"
                                id="page_content"
                                {...register("page_content", {
                                  required: "Page content is required",
                                  // pattern: {
                                  //   value: /^[a-zA-Z0-9.,/_( )\n\r-]+$/,
                                  //   message:
                                  //     "Only alphanumeric characters and [ , . / - _ ( )] are allowed",
                                  // },
                                })}
                                className="form-control"
                                value={watch("page_content")}
                                onChange={(e) => {
                                  setValue("page_content", e.target.value);
                                  trigger("page_content");
                                }}
                              />
                              {errors.page_content && (
                                <span className="invalid">{errors?.page_content?.message}</span>
                              )}
                            </div>
                      </> }
                    </Col>
                  )}
                  {/* CK EDITOR Hindi */}
                  {(watch("page_type")?.value == "Static" || watch("page_type")?.value == "Link") && (
                      <Col md="12" sm="12" xxl="6">
                        {isCKEditor ? (
                          <>
                            {/* COMMENTED FOR AUDIT */}
                            <CKEditor title={"Page Content in Hindi"} id={"pagehn"} />
                          </>
                        ) : (
                          <>
                            {/* REMOVE AFTER AUDIT */}
                            <Label htmlFor="page_content_hn" className="form-label">
                              {"Page Content in Hindi"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <textarea
                                rows={15}
                                placeholder={"Enter page content in hindi"}
                                type="text"
                                id="page_content_hn"
                                {...register("page_content_hn", {
                                  required: "Page content in hindi is required",
                                  // pattern: {
                                  //   value: /^[a-zA-Z0-9.,/_( )\n\r-]+$/,
                                  //   message:
                                  //     "Only alphanumeric characters and [ , . / - _ ( )] are allowed",
                                  // },
                                })}
                                className="form-control"
                                value={watch("page_content_hn")}
                                onChange={(e) => {
                                  setValue("page_content_hn", e.target.value);
                                  trigger("page_content_hn");
                                }}
                              />
                              {errors.page_content_hn && (
                                <span className="invalid">{errors?.page_content_hn?.message}</span>
                              )}
                            </div>
                          </>
                        )}
                      </Col>
                    )}
                </Row>
                <Col md="2" className={``}>
                  <div className="form-group" style={{ marginTop: "31px" }}>
                    <Button disabled={isLoading} color="primary" size="md">
                      {isLoading ? <Spinner size="sm" color="primary" /> : mode == "Add" ? "Save" : "Update"}
                    </Button>
                  </div>
                </Col>
              </Form>
            </PreviewAltCard>
          </Row>
        </Block>
      </Content>
    </>
  );
};

export default SubMenu;
